import { map } from 'rxjs/operators';
import { EncoderService } from '../encoder';
import { UserPreferencesAPIService } from './user-preferences.api.service';
import * as i0 from "@angular/core";
import * as i1 from "./user-preferences.api.service";
import * as i2 from "../encoder/encoder.service";
export class UserPreferencesService {
    constructor(apiService, encoder) {
        this.apiService = apiService;
        this.encoder = encoder;
        this.context = 'taxManager';
    }
    updateUserPreference(data, subcontext, identifier = '') {
        const request = {
            context: this.context,
            subcontext,
            identifier,
            data: this.encoder.encode(data)
        };
        return this.apiService
            .updateUserPreference(request)
            .pipe(map(response => this.encoder.decode(response.data)));
    }
    deleteUserPreference(subcontext, identifier = '') {
        const request = {
            context: this.context,
            subcontext,
            identifier
        };
        return this.apiService.deleteUserPreference(request);
    }
    listUserPreferences(subcontext, identifier = '') {
        const request = {
            filter: {
                context: this.context,
                subcontext,
                identifier
            }
        };
        return this.apiService.listUserPreferences(request);
    }
    getUserPreference(subcontext, identifier = '') {
        return this.listUserPreferences(subcontext, identifier).pipe(map(response => {
            const preference = response.find(userPreference => userPreference.identifier === identifier);
            if (!preference || !preference.data) {
                return null;
            }
            return this.encoder.decode(preference.data);
        }));
    }
}
UserPreferencesService.ngInjectableDef = i0.defineInjectable({ factory: function UserPreferencesService_Factory() { return new UserPreferencesService(i0.inject(i1.UserPreferencesAPIService), i0.inject(i2.EncoderService)); }, token: UserPreferencesService, providedIn: "root" });
